import React, { useState } from "react";
import { mainMenu } from "./Constants";
import { useNavigate } from "react-router";

const Navbar = () => {
  const navigate = useNavigate();
  const [isMenu, setIsMenu] = useState(false);
  const [isSubMenuOpen, setSubMenuOpen] = useState(false);
  // const [isSubMenu, setSubIsMenu] = useState("")

  const handleSubMenu = (e, r) => {
    if (e == "Blogs") {
      // setSubMenuOpen(!isSubMenuOpen);
      // console.log(isSubMenuOpen);
    } else {
      setSubMenuOpen(false);
    }
    setIsMenu(!isMenu);
    // navigate(r)
  };

  function handleRoute(e) {
    navigate(e);
    console.log(e);
  }

  return (
    <>
      <div className="md:flex hidden flex-1 justify-end">
        {mainMenu.map((data, key) => {
          return (
            <div className="" key={"adminMenu" + key}>
              <button
                className="py-3 text-center w-28 hover:text-secondary hover:font-medium"
                onClick={() => {
                  handleSubMenu(data.name);
                }}
              >
                <span
                  className="flex justify-center"
                  onClick={() => {
                    handleRoute(data.route);
                  }}
                >
                  {data.name}
                  {data.subMenu && (
                    <span>
                      {!isSubMenuOpen ? (
                        <svg
                          className="ml-1 mt-1 w-4 h-4"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M4.5 15.75l7.5-7.5 7.5 7.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="ml-1 mt-1 w-4 h-4"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                          />
                        </svg>
                      )}
                    </span>
                  )}
                </span>
              </button>
              {isSubMenuOpen && (
                <div className="relative flex justify-center">
                  {data.subMenu && (
                    <div className="flex flex-col absolute border-2 border-gray-400 bg-secondary w-40 py-1 md:space-y-2 text-center">
                      {data.subMenu.map((subData, subKey) => {
                        return (
                          <div className="">
                            <button className=" py-2 w-full hover:bg-primary">
                              {subData.name}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* burgger menu */}

      <div className="md:hidden flex z-10">
        <div
          className=""
          onClick={() => {
            setIsMenu(!isMenu);
          }}
        >
          <svg
            className="md:w-10 md:h-10 h-7 w-7"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </div>
        {isMenu && (
          <div className=" absolut e fixed top-0 right-0 w-screen h-screen flex justify-end bg-black bg-opacity-5 backdrop-blur-sm">
            <div className="bg-primary w-11/12 p-2 h-full flex flex-col">
              <div
                className="w-full flex justify-end"
                onClick={() => {
                  setIsMenu(!isMenu);
                }}
              >
                <svg
                  className="w-16 h-16 pr-6 pt-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <div className="flex flex-col mt-20 h-full">
                {mainMenu.map((data, key) => {
                  return (
                    <>
                      <button
                        className="text-lg flex justify-center my-2 py-3"
                        onClick={() => {
                          handleSubMenu(data.name);
                        }}
                      >
                        <span
                          onClick={() => {
                            handleRoute(data.route);
                          }}
                        >
                          {data.name}
                        </span>
                        {data.subMenu && (
                          <span className="flex">
                            {!isSubMenuOpen ? (
                              <svg
                                className="ml-1 mt-1 w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M4.5 15.75l7.5-7.5 7.5 7.5"
                                />
                              </svg>
                            ) : (
                              <svg
                                className="ml-1 mt-1 w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                />
                              </svg>
                            )}
                          </span>
                        )}
                      </button>
                      {isSubMenuOpen && (
                        <div className="flex justify-center bg-secondary focus:bg-primary">
                          {data.subMenu && (
                            <div className="flex flex-col p-2 w-full">
                              {data.subMenu.map((subData, subKey) => {
                                return (
                                  <div className="">
                                    <button className=" py-2 w-full hover:bg-primary">
                                      {subData.name}
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
